export interface PopupPlacement {
  /** Viewport-relative `top` (px) for the position:fixed popup. */
  top: number;
  /** True when the popup was flipped ABOVE the caret (not enough room below). */
  above: boolean;
}

/**
 * Where to put the @-mention picker relative to the caret. The picker is
 * position:fixed on <body>, so its only constraint is the viewport. It sits below
 * the caret by default, but flips above when it doesn't fit below AND there's more
 * room above — otherwise a composer low in the viewport clips the list (the reported
 * bug). The flipped `top` is clamped to `margin` so it never runs off the top edge;
 * the list's own `overflowY:auto` scrolls whatever still doesn't fit.
 */
export function mentionPopupPlacement(opts: {
  caretTop: number;
  caretBottom: number;
  popupHeight: number;
  viewportHeight: number;
  margin?: number;
}): PopupPlacement {
  const margin = opts.margin ?? 5;
  const spaceBelow = opts.viewportHeight - opts.caretBottom - margin;
  const spaceAbove = opts.caretTop - margin;
  const above = opts.popupHeight > spaceBelow && spaceAbove > spaceBelow;
  const top = above
    ? Math.max(margin, opts.caretTop - opts.popupHeight - margin)
    : opts.caretBottom + margin;
  return { top, above };
}
